/**
 * @extends com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKCobrowseMessageHandler = function () {
	this.constructor.__super__.call(this);
	/** @type {object} */
	this.xssModule = require("xss");
};
$hxClasses.extend(
	com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler,
	com.inq.flash.client.control.messagehandlers.CMSDKCobrowseMessageHandler,
	"com.inq.flash.client.control.messagehandlers.CMSDKCobrowseMessageHandler"
);

com.inq.flash.client.control.messagehandlers.CMSDKCobrowseMessageHandler.prototype.processMessage = function (message) {
	/** @type {?string} */
	var agentName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_AGENT_ALIAS);
	/** @type {?string} */
	var quiet = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_CUSTOMER_QUIET);
	/** @type {boolean} */
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) == "1";

	/** @type {?string} */
	var agentId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USER_ID);

	var chatText = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA);

	// Remove any javascript in messages. removeJSInMessages	
	chatText = this.getFilteredText(chatText);
	message.setPropertyIfNotNullIfExists(
		com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA,
		chatText
	);

	if (agentName != null) {
		/** @type {string} */
		var cobrowseEvent = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT);
		if (com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_END != cobrowseEvent) {
			chatText = this.handleCobrowseActionsInAttributes(chatText, cobrowseEvent);
			chatText = this.handleCustomEventAttributes(chatText);
			message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA, chatText);
			if (com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE_TEST == cobrowseEvent // it's used for ATT eligibility test
				&& !replay) {
				this.executeCobrowseGetHTMLTest();
			} if (this.isCobrowseInvite(cobrowseEvent)) {
				this.controller.onNewChatRouterMessage(message);
			} else if (this.isCobrowseSharedInvite(cobrowseEvent)) {
				this.controller.onNewChatRouterMessage(message);
			} else if (com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_FAIL_NO_CONNECTION == cobrowseEvent // it's used for ATT eligibility test
				&& !replay) {
				this.sendCobrowseTestResult(false, agentId);
			}
		} else {
			/** @type {string} */
			var agentType = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_TYPE);
			if (com.inq.flash.client.data.MessageFields.DATA_AGENT_TYPE_FLEX == agentType && !replay) {
				/** @type {string} */
				var windowId = message.getProperty(com.inq.flash.client.data.MessageFields.WINDOW_ID_PARAM);
				com.inq.flash.client.chatskins.CoBrowseMgr.endCobByEtlEvent(windowId);
			}
		}
	} else {
		if (!quiet) {
			this.controller.onNewChatRouterMessage(message);
		} else {
			this.controller.onNewChatRouterQuietMessage(replay);
		}
	}
};
